import { useAppTranslation } from 'app/config/i18Config/hooks';
import { useAppDispatch } from 'app/config/storeConfig/hooks';
import { FC, memo } from 'react';
import { ReactComponent as ArrowRight } from 'shared/assets/icons/ArrowRight.svg';
import { ForgotPasswordSteps } from 'widgets/AuthForm';
import { logInModalActions } from '../model/slice/loginModalSlice';

export const ForgotPasswordForm: FC = memo(() => {
  const { t } = useAppTranslation(['login-page', 'common']);

  const dispatch = useAppDispatch();

  const openAuthScreen = (): void => {
    dispatch(logInModalActions.changeMode('login'));
  };

  const handleSuccess = (): void => {
    dispatch(logInModalActions.setOpened(false));
  };

  return (
    <>
      <div className="flex items-center text-sm text-accent cursor-pointer mb-10" onClick={openAuthScreen}>
        <ArrowRight className="[&>path]:stroke-accent rotate-180 mr-2 w-5" />
        {t('Go back')}
      </div>
      <ForgotPasswordSteps onSuccess={handleSuccess} />
    </>
  );
});
